import * as React from "react";
import { ModalPlm } from "src/components/ModalPlm";
import { Form, Input } from "antd";
import { trimRequired } from "src/common/validationRules/trimRequired";
import { ImageCarousel } from "src/components/ImageCarousel";
import { onError } from "src/common/onError";
import styles from "./Mc2EditorModal.module.less";
import { Mc2Fields } from "../Mc2Types";
import { SelectSizeLine } from "./SelectSizeLine";
import { mc2SummaryStore } from "./mc2SummaryStore";

/* eslint react/no-unstable-nested-components: "off" */

interface PropsMc2EditorModal {
  open: boolean;
  close: () => void;
  title: string;
  initialValues?: Mc2Fields;
  onSelect(data: Mc2Fields): Promise<void>;
  disableSizeLine?: boolean;
  sizeLineAttrNameId: string;
}

export const Mc2EditorModal: React.FC<PropsMc2EditorModal> = (props) => {
  const {
    open,
    close,
    title,
    initialValues,
    onSelect,
    disableSizeLine,
    sizeLineAttrNameId,
  } = props;
  const [form] = Form.useForm();
  const [sizeLineName, setSizeLineName] = React.useState("");
  const [saving, setSaving] = React.useState(false);
  React.useEffect(() => {
    if (open) {
      form.resetFields();
      form.setFieldsValue(initialValues);
      setSizeLineName(initialValues?.sizeLineName ?? "");
    }
  }, [open]);
  const onSubmit = (values: Mc2Fields) => {
    setSaving(true);
    onSelect({
      ...values,
      sizeLineName,
    })
      .finally(() => setSaving(false))
      .then(close)
      .catch(onError);
  };
  return (
    <ModalPlm
      height="80vh"
      width="800px"
      open={open}
      onCancel={close}
      title={title}
      okText="Сохранить"
      okButtonProps={{ htmlType: "submit", loading: saving }}
      modalRender={(content) => (
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          initialValues={initialValues}
        >
          {content}
        </Form>
      )}
    >
      <div className={styles.formContent}>
        <Form.Item name="name" label="Название" rules={[trimRequired()]}>
          <Input allowClear />
        </Form.Item>
        <Form.Item
          name="sizeLineId"
          label="Размерный ряд"
          rules={disableSizeLine ? undefined : [trimRequired()]}
        >
          <SelectSizeLine
            disabled={disableSizeLine}
            objSizeLineId={mc2SummaryStore.settings.objSizeLineId ?? ""}
            sizeLineAttrNameId={sizeLineAttrNameId}
            sizeLineName={sizeLineName}
            onChangeName={(name) => {
              setSizeLineName(name);
            }}
          />
        </Form.Item>
        <Form.Item
          name="comment"
          label="Комментарий"
          style={{ gridColumn: "span 3" }}
        >
          <Input.TextArea allowClear />
        </Form.Item>
        <Form.Item name="images" label="Изображение">
          <ImageCarousel multiple />
        </Form.Item>
      </div>
    </ModalPlm>
  );
};
